import { UIState } from '../reducers/ui.reducer';
import { RootState } from '../store.ts';

const getUIState = (state: RootState): UIState => state.ui;
const getLoadingState = (state: RootState, key: string): boolean => getUIState(state).loadingStates[key] || false;

export const getIsLoadingProjects = (state: RootState): boolean => getLoadingState(state, 'loadProjects');
export const getIsLoadingFolder = (state: RootState): boolean => getLoadingState(state, 'loadFolder');
export const getIsLoadingMoreProjects = (state: RootState): boolean => getLoadingState(state, 'loadMoreProjects');
export const getIsLoadingExampleProjects = (state: RootState): boolean => getLoadingState(state, 'loadExampleProjects');
export const getIsCloningExampleProject = (state: RootState): boolean => getLoadingState(state, 'cloneExampleProject');
export const getUploadProgress = (state: RootState) => getUIState(state).uploadProgress;
export const getIsRedirecting = (state: RootState): boolean => getUIState(state).isRedirecting;
export const getShowPaywall = (state: RootState): boolean => getUIState(state).showPaywall;
export const getShowTutorials = (state: RootState): boolean => getUIState(state).showTutorials;
